import React, { useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import ModalDataContext from './modalDataProvider.context';
import { useDataLayer } from '../../../../hooks/useDataLayer';

export const ModalDataProvider = function ({ children }) {
  const [showModal, setShowModal] = useState(false);
  const registerEvent = useDataLayer();
  const toggleModal = useCallback(() => {
    setShowModal((oldshow) => {
      const show = !oldshow;
      if (show) registerEvent({ event: 'register-form-open' });
      return show;
    });
  }, [registerEvent]);

  const forceShowModal = useCallback(() => {
    registerEvent({ event: 'register-form-open' });
    setShowModal(true);
  }, [registerEvent]);

  const value = useMemo(
    () => ({ showModal, toggleModal, forceShowModal }),
    [showModal, toggleModal, forceShowModal],
  );

  return (
    <ModalDataContext.Provider value={value}>
      {children}
    </ModalDataContext.Provider>
  );
};

ModalDataProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ModalDataProvider;
